
<div class="content-general">
    <div class="section-content section-last-articles">
        <h3 class="title-row">Ultimi Articoli</h3>
        <div class="card-container-article">
            <div class="card-info" *ngFor="let item of articles" (click)="getSingleArticle(item.environment, item.category, item.id)">
                <!--<div class="image-container">
                    <div class="image" [ngStyle]="{'background-image': 'url(' + item.images + ')'}"></div>
                </div>-->
                <div class="box-content">
                    <h3 class="title">{{item.title}}</h3>
                    <p [innerHTML]="item.article | truncate:[80, '...']"></p>
                    <div class="tags"><span *ngFor="let tag of item.tags | split:[',']" [textContent] = "tag"></span></div>
                </div>
            </div>
        </div>
    </div>

    <!--<div class="line-separation"></div>

    <div class="section-content section-last-guides">
        <h3 class="title-row">Guida Html</h3>
        <div class="card-container">
            <div class="card-guide">
                <div class="box-content">
                    <div *ngFor="let item of guides">
                        <p>{{item.title}}</p>
                        <div *ngIf="item.tags != null" class="tags"><span *ngFor="let tag of item.tags | split:[',']" [textContent] = "tag"></span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->

    <div class="line-separation"></div>

    <div class="section-content section-utility">
        <h3 class="title-row">Qualcosa di utile</h3>
        <div class="card-container">
            <div class="card-info" *ngFor="let item of utilities">
                <a [href]="item.link" alt="" target="_blank">
                    <div class="image-container">
                        <div class="image" [ngStyle]="{'background-image': 'url(' + item.image + ')'}"></div>
                    </div>
                    <div class="box-content">
                        <h3 class="title">{{item.title}}</h3>
                    </div>
                </a>
            </div>
        </div>
    </div>

    <!--<div class="content-button-bottom">
        <a routerLink="../symbol-character" type="button">Entità Carattere (ISO)</a>
    </div>-->
</div>
